<template>
  <ColumnsEffect>
    <div
      v-for="source of items"
      :key="source.uid"
      class="column is-3 is-marginless is-paddingless"
      @contextmenu.prevent="$emit('menu', { e: $event, source: source })"
    >
      <router-link v-if="!source.edit" :to="`/repos/${source.uid}`">
        <span class="icon">
          <i class="mdi mdi-database"></i>
        </span>
        <span>{{ source.name }}</span>

        <span
          v-if="!source.external && source.version >= 2"
          class="icon"
          data-tooltip="High capability repo"
        >
          <i class="mdi mdi-alpha-h-circle-outline"></i>
        </span>

        <span v-if="source.shared" class="icon" data-tooltip="Shared with you">
          <i class="mdi mdi-share-variant"></i>
        </span>
      </router-link>
      <EditSingleField
        v-if="source.edit"
        :text="source.name"
        validation="required"
        type="text"
        name="name"
        @save="$emit('save', { source: source, text: $event })"
        @cancel="$emit('cancel', source)"
        :isLoading="source.saving"
      ></EditSingleField>
    </div>
  </ColumnsEffect>
</template>

<script>
import permissions from "@/utils/permission.js";

export default {
  props: { items: Array },
  components: {
    ColumnsEffect: () => import("@/components/singles/ColumnsEffect.vue"),

    EditSingleField: () =>
      import("@/components/singles/EditSingleField/component.vue"),
  },
  computed: {
    permission() {
      return (source) => {
        if (source.permission) return permissions.source[source.permission];
        else return "Owner";
      };
    },
  },
};
</script>
